import { render, staticRenderFns } from "./AliasesTable.vue?vue&type=template&id=0ec63d16&"
import script from "./AliasesTable.vue?vue&type=script&lang=js&"
export * from "./AliasesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec63d16')) {
      api.createRecord('0ec63d16', component.options)
    } else {
      api.reload('0ec63d16', component.options)
    }
    module.hot.accept("./AliasesTable.vue?vue&type=template&id=0ec63d16&", function () {
      api.rerender('0ec63d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/Aliases/AliasesTable.vue"
export default component.exports